<div class="kpi-tile">
  <div class="label">{{ label }}</div>
  <div class="value">{{ value | number }}</div>
  <app-comparison-badge
    class="display-block mt--xs"
    [value]="comparisonValue"
    [digits]="hasPercent ? 1 : 0"
    [suffix]="hasPercent ? '%' : ''">
  </app-comparison-badge>
</div>
